import TopUpOptionItem from "../TopUpOptionItem/TopUpOptionItem"
import {
  Container,
  TitleContainer,
  TitleText,
  OptionsContainer,
  OptionItemWrapper,
  OptionDivider
} from "./TopUpOptionList.styles"

export type TopUpOptionListOption = {
  iconUrl: string
  name?: string
  boldName?: string
  grayName?: string
  selectedValue?: string
  isDisabled?: boolean
  iconPlaceholder?: 'bank' | 'crypto',
}

export type TopUpOptionListProps = {
    options: TopUpOptionListOption[]
    title?: string
    onClick: (option: TopUpOptionListOption) => void
    selectedValue?: string,
    outline?: boolean
}

const TopUpOptionList = ({
    options,
    title,
    onClick,
    selectedValue,
    outline = true
}: TopUpOptionListProps) => {
    return (
        <Container style={{ borderStyle: outline ? 'solid' : 'none' }}>
            {title && (
              <TitleContainer>
                <TitleText>{title}</TitleText>
              </TitleContainer>
            )}
            <OptionsContainer style={{ padding: outline ? '16px 12px' : '0' }}>
                {options.map((option, index) => {
                  return (
                      <OptionItemWrapper key={index}>
                        <TopUpOptionItem
                            iconUrl={option.iconUrl}
                            name={option.name}
                            boldName={option.boldName}
                            grayName={option.grayName}
                            disabled={option.isDisabled}
                            onClick={() => onClick(option)}
                            checked={
                                !!selectedValue && (
                                option.name === selectedValue ||
                                option.boldName === selectedValue ||
                                option.grayName === selectedValue ||
                                option.iconUrl === selectedValue )
                            }
                            iconPlaceholder={option.iconPlaceholder}
                        />
                        {index !== options.length - 1 && <OptionDivider />}
                      </OptionItemWrapper>
                    )
                })}
            </OptionsContainer>
        </Container>
    )
}

export default TopUpOptionList
